<template>
  <div>
    <el-dialog
      title="预约咨询员信息"
      :visible="true"
      width="90%"
      class="teacherTelInfo"
      :show-close="false"
    >
      <!-- <p class="title">预约咨询员信息</p> -->
      <table class="c-talbe">
        <tr>
          <td class="text-right" width="100">手机</td>
          <td>{{operatorContact.loginPhone}}</td>
        </tr>
        <tr>
          <td class="text-right">电话</td>
          <td>{{operatorContact.localPhone}}</td>
        </tr>
        <tr>
          <td class="text-right">微信</td>
          <td>{{operatorContact.wxcode}}</td>
        </tr>
        <tr>
          <td class="text-right">地址</td>
          <td>{{operatorContact.address}}</td>
        </tr>
      </table>
      <p class="text-center">
        <span style="color: #f00; line-height: 25px">备注</span><br />
        座机电话时间：{{operatorContact.serviceTime}}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          round
          style="width: 100%"
          @click="close"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default { 
  props: {
    operatorContact: Object,
  },   
  data() {
    return {
    };
  },
  mounted() {   
  },  
  methods: {
    close(){
      this.$emit('close-contact');
    },
  }
};
</script>

<style scoped>
>>> .el-dialog__header{
  text-align: center;
}
.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}
</style>
